import { render, staticRenderFns } from "./MinimumUpdateProfile.vue?vue&type=template&id=1d38f413&scoped=true&"
import script from "./MinimumUpdateProfile.vue?vue&type=script&lang=ts&"
export * from "./MinimumUpdateProfile.vue?vue&type=script&lang=ts&"
import style0 from "./MinimumUpdateProfile.vue?vue&type=style&index=0&id=1d38f413&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d38f413",
  null
  
)

export default component.exports